// --------------------------------------------------
// API 请求响应的对应 CODE 编号列表
// --------------------------------------------------

export const SUCCESS = '000';
export const FAIL_BUSINESS = 40001;
export const OVER_TIME = '111';
